import React, { useState } from 'react';

export default function AddTask({ role, setAddTask, onTaskAdded }) {
  const [task, setTask] = useState('');

  const handleSave = async () => {
    const data = { task: task, id: role.id };
  
    try {
      const response = await fetch('https://api.insightos.co.uk/api/addtask', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(data)
      });
  
      const result = await response.json(); // Parse JSON response
  
      if (response.ok && result.success) { // Check both HTTP status and API success flag
        onTaskAdded(); // Notify the parent to re-fetch and hide this component
      } else {
        console.log(result.message);
      }
    } catch (error) {
      console.log(error);
    }
  };
  

  return (
    <>
      <div>
        <div className="mt-2">
          <input
            onChange={(e) => setTask(e.target.value)}
            id="task"
            name="task"
            type="text"
            placeholder="Add Task"
            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm"
          />
        </div>
      </div>
      <div className="mt-2">
        <button
          onClick={handleSave}
          className="rounded bg-indigo-600 mr-2 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Add Task
        </button>
        <button
          onClick={() => setAddTask(null)}
          className="rounded bg-red-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Cancel
        </button>
      </div>
    </>
  );
}

